import React, { useContext } from 'react';
import styled from '@emotion/styled';
import Tooltip from '@atlaskit/tooltip';
import { GlobalContext } from '../common/GlobalContext';
import { token } from '@atlaskit/tokens';

/*
 * USAGE:
 * <CepCustomFieldTypeIcon
 *   icon="cascading"
 *   color="#fff"
 *   size="normal"
 * ></CepCustomFieldTypeIcon>
 */

const allowedTypes = ['cascadingselect', 'multicheckboxes', 'multiselect', 'radiobuttons', 'select' /*'multi-level-cascading-select'*/];

/* tslint:disable max-line-length */

const incompatible = (
  <>
    <path fill="none" d="M-.001-.002H590.55V590.55H-.001z" />
    <path
      d="M531.319 107.278c0-26.653-21.64-48.292-48.292-48.292H107.57c-26.652 0-48.291 21.64-48.291 48.292V483.38c0 26.652 21.639 48.291 48.29 48.291h375.46c26.651 0 48.29-21.639 48.29-48.291V107.278zm-19.957 0V483.38c0 15.637-12.694 28.333-28.335 28.333H107.57c-15.64 0-28.334-12.696-28.334-28.333V107.278c0-15.638 12.693-28.333 28.334-28.333h375.458c15.641 0 28.335 12.695 28.335 28.333z"
      fill={token('color.text.subtle', '#253858')}
    />
    <path d="M206.278 288.766h161.51v27.752h-161.51z" fill={token('color.text.subtle', '#253858')} transform="rotate(45 324.799 249.08) scale(1.17283 1)" />
    <path d="M206.278 288.766h161.51v27.752h-161.51z" fill={token('color.text.subtle', '#253858')} transform="rotate(-45 307.14 348.89) scale(1.17283 1)" />
  </>
);

const select = (
  <>
    <path fill="none" d="M-.001-.002H590.55V590.55H-.001z" />
    <path
      d="M531.319 107.278c0-26.653-21.64-48.292-48.292-48.292H107.57c-26.652 0-48.291 21.64-48.291 48.292V483.38c0 26.652 21.639 48.291 48.29 48.291h375.46c26.651 0 48.29-21.639 48.29-48.291V107.278zm-19.957 0V483.38c0 15.637-12.694 28.333-28.335 28.333H107.57c-15.64 0-28.334-12.696-28.334-28.333V107.278c0-15.638 12.693-28.333 28.334-28.333h375.458c15.641 0 28.335 12.695 28.335 28.333z"
      fill={token('color.text.subtle', '#253858')}
    />
    <path
      d="M239.4 383.856V206.691h-28.6c-1.012 6.833-3.036 12.401-6.327 16.957-3.29 4.556-7.086 8.352-11.642 10.883-4.809 2.784-10.124 4.809-15.692 5.821-5.82 1.266-11.895 1.772-18.222 1.519v27.08h44.544v114.905h35.94zM412.04 398.497l53.398-71.185H358.631l53.41 71.185zM412.04 192.049l53.398 71.208H358.631l53.41-71.208z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
  </>
);

const multiselect = (
  <>
    <path fill="none" d="M-.001-.002H590.55V590.55H-.001z" />
    <path
      d="M531.319 107.278c0-26.653-21.64-48.292-48.292-48.292H107.57c-26.652 0-48.291 21.64-48.291 48.292V483.38c0 26.652 21.639 48.291 48.29 48.291h375.46c26.651 0 48.29-21.639 48.29-48.291V107.278zm-19.957 0V483.38c0 15.637-12.694 28.333-28.335 28.333H107.57c-15.64 0-28.334-12.696-28.334-28.333V107.278c0-15.638 12.693-28.333 28.334-28.333h375.458c15.641 0 28.335 12.695 28.335 28.333z"
      fill={token('color.text.subtle', '#253858')}
    />
    <path
      d="M237.7 279.132V111.415h-27.073c-.959 6.47-2.875 11.74-5.99 16.053-3.115 4.313-6.709 7.907-11.022 10.303-4.552 2.635-9.583 4.552-14.854 5.51-5.511 1.199-11.261 1.678-17.251 1.438v25.637h42.168v108.776h34.023zM143.185 378.346h31.946c0-4.463.47-8.69 1.41-13.389.704-4.463 2.113-8.456 4.227-12.214 2.114-3.524 4.698-6.577 8.222-8.926 3.288-2.115 7.281-3.289 12.214-3.289 7.282 0 13.155 2.114 17.852 6.577 4.464 4.463 6.813 10.805 6.813 18.792 0 4.933-1.175 9.396-3.29 13.389-2.348 3.993-5.167 7.517-8.455 10.57a100.791 100.791 0 01-11.275 8.457c-3.994 2.584-7.987 5.167-11.51 7.751-7.047 4.933-13.624 9.631-19.967 14.33-6.342 4.697-11.98 9.865-16.677 15.267-4.698 5.638-8.457 11.98-11.04 19.027-2.82 7.047-4.229 15.268-4.229 24.9h120.737V450.93h-77.75a70.238 70.238 0 0114.093-14.799c5.403-4.228 10.806-8.221 16.443-11.98 5.638-3.523 11.275-7.281 16.913-11.04a95.827 95.827 0 0014.798-12.684c4.463-4.463 7.987-9.866 10.57-15.738 2.585-5.873 3.994-13.155 3.994-21.376 0-7.986-1.41-15.268-4.463-21.61-3.054-6.343-7.282-11.745-12.45-16.208-5.167-4.463-11.275-7.752-17.852-10.101-6.812-2.349-14.094-3.523-21.61-3.523-9.866 0-18.557 1.644-26.074 4.932-7.752 3.524-14.094 8.222-19.027 14.094-4.932 6.108-8.69 13.154-11.275 21.141-2.584 8.221-3.523 16.913-3.288 26.308zM412.04 398.497l53.398-71.185H358.631l53.41 71.185zM412.04 192.049l53.398 71.208H358.631l53.41-71.208z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
  </>
);
const cascadingselect = (
  <>
    <path fill="none" d="M-.001 0H590.55v590.552H-.001z" />
    <path
      d="M297.083 345.426V168.26h-28.6c-1.012 6.834-3.037 12.402-6.327 16.958-3.29 4.555-7.086 8.352-11.642 10.883-4.809 2.784-10.124 4.808-15.692 5.82-5.821 1.266-11.895 1.772-18.223 1.52v27.08h44.545v114.905h35.94z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
    <path
      d="M454.84 109.162c0-28.072-22.79-50.861-50.863-50.861H109.703c-28.074 0-50.863 22.79-50.863 50.86v294.276c0 28.072 22.79 50.862 50.863 50.862h294.274c28.074 0 50.864-22.79 50.864-50.862V109.162zm-20.834 0c0-16.573-13.45-30.028-30.029-30.028H109.703c-16.57 0-30.029 13.455-30.029 30.028v294.275c0 16.574 13.46 30.03 30.029 30.03h294.274c16.579 0 30.029-13.456 30.029-30.03V109.162z"
      fill={token('color.text.subtle', '#253858')}
    />
    <path
      d="M195.571 531.334h294.275c22.899 0 41.487-18.59 41.487-41.486V195.572c0-6.324-5.129-11.458-11.458-11.458-6.32 0-11.459 5.134-11.459 11.458v294.276c0 10.249-8.32 18.57-18.57 18.57H195.571c-6.32 0-11.458 5.134-11.458 11.458s5.138 11.458 11.458 11.458z"
      fill={token('color.text.subtle', '#253858')}
    />
  </>
);
const radiobuttons = (
  <>
    <path fill="none" d="M-.001-.002H590.55V590.55H-.001z" />
    <path
      d="M153.165 260.842c-52.108 0-94.489-42.382-94.489-94.489 0-52.107 42.381-94.488 94.489-94.488 52.107 0 94.488 42.381 94.488 94.488s-42.38 94.489-94.488 94.489zm0-163.78c-38.211 0-69.292 31.08-69.292 69.291s31.08 69.292 69.292 69.292c38.21 0 69.291-31.08 69.291-69.292 0-38.21-31.08-69.291-69.291-69.291z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
    <circle cx="10.5" cy="14.5" r="2.5" fill={token('color.text.subtle', '#253858')} transform="matrix(12.59848 0 0 12.59844 20.88 -16.324)" />
    <path
      d="M153.164 518.684c-52.107 0-94.488-42.38-94.488-94.488 0-52.107 42.381-94.489 94.488-94.489s94.489 42.382 94.489 94.489c0 52.107-42.382 94.488-94.489 94.488zm0-163.78c-38.21 0-69.291 31.093-69.291 69.292 0 38.198 31.08 69.291 69.291 69.291s69.292-31.093 69.292-69.291c0-38.199-31.08-69.292-69.292-69.292zM469.512 246.386V69.22h-28.6c-1.012 6.834-3.037 12.402-6.327 16.958-3.29 4.555-7.086 8.352-11.642 10.883-4.809 2.784-10.124 4.808-15.692 5.82-5.821 1.266-11.895 1.772-18.223 1.52v27.08h44.545v114.905h35.94z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
    <g>
      <path
        d="M377.995 413.367h33.746c0-4.715.496-9.181 1.489-14.144.744-4.714 2.233-8.933 4.466-12.903 2.234-3.722 4.963-6.947 8.685-9.429 3.474-2.233 7.692-3.473 12.903-3.473 7.692 0 13.895 2.233 18.858 6.947 4.714 4.715 7.195 11.414 7.195 19.85 0 5.211-1.24 9.926-3.473 14.144-2.482 4.218-5.46 7.94-8.933 11.166a106.47 106.47 0 01-11.91 8.933c-4.219 2.73-8.437 5.459-12.159 8.188-7.444 5.21-14.391 10.173-21.09 15.136-6.7 4.963-12.656 10.421-17.618 16.128-4.963 5.956-8.933 12.655-11.662 20.099-2.978 7.444-4.467 16.129-4.467 26.302h127.54v-30.272h-82.132a74.195 74.195 0 0114.888-15.632c5.707-4.467 11.414-8.685 17.37-12.655 5.954-3.722 11.91-7.692 17.865-11.662a101.225 101.225 0 0015.632-13.4c4.714-4.714 8.436-10.42 11.166-16.624 2.73-6.203 4.218-13.895 4.218-22.58 0-8.436-1.489-16.128-4.714-22.828-3.226-6.7-7.693-12.406-13.151-17.12-5.46-4.715-11.91-8.19-18.858-10.67-7.196-2.482-14.888-3.722-22.828-3.722-10.422 0-19.603 1.737-27.543 5.21-8.188 3.722-14.888 8.685-20.098 14.888-5.211 6.452-9.181 13.895-11.91 22.332-2.73 8.684-3.723 17.865-3.475 27.79z"
        fill={token('color.text.subtle', '#253858')}
        fillRule="nonzero"
      />
    </g>
  </>
);
const multicheckboxes = (
  <>
    <path fill="none" d="M-.001 0H590.55v590.552H-.001z" />
    <path
      d="M256.877 365.526c0-17.84-14.49-32.324-32.326-32.324H91.644c-17.837 0-32.327 14.483-32.327 32.324v133.506c0 17.844 14.49 32.33 32.327 32.33H224.55c17.836 0 32.326-14.486 32.326-32.33V365.526zm-20.832 0v133.506c0 6.346-5.152 11.498-11.494 11.498H91.644c-6.342 0-11.486-5.152-11.486-11.498V365.526c0-6.342 5.144-11.491 11.486-11.491H224.55c6.342 0 11.494 5.149 11.494 11.491zM246.28 68.122c-5.742-5.219-13.37-8.4-21.73-8.4H91.645c-17.837 0-32.327 14.483-32.327 32.323v133.506c0 17.845 14.49 32.33 32.327 32.33H224.55c17.836 0 32.326-14.485 32.326-32.33v-86.457c0-.556-20.832 19.171-20.832 19.171v67.286c0 6.346-5.152 11.499-11.494 11.499H91.644c-6.342 0-11.486-5.153-11.486-11.499V92.045c0-6.342 5.144-11.491 11.486-11.491H224.55c2.528 0 5.1.543 6.764 2.205.238.24 15.212-14.408 14.966-14.637z"
      fill={token('color.text.subtle', '#253858')}
    />
    <path d="M151.119 179.937l-34.79-37.194-18.543 17.344 34.82 37.226-.08.074 17.376 18.514L300.767 75.003 283.39 56.489 151.12 179.937z" fill={token('color.text.subtle', '#253858')} />
    <path
      d="M469.512 246.388V69.222h-28.6c-1.012 6.834-3.037 12.402-6.327 16.958-3.29 4.555-7.086 8.352-11.642 10.883-4.809 2.784-10.124 4.808-15.692 5.82-5.821 1.266-11.895 1.772-18.223 1.52v27.08h44.545v114.905h35.94zM377.995 413.369h33.746c0-4.715.496-9.181 1.489-14.144.744-4.714 2.233-8.933 4.466-12.903 2.234-3.722 4.963-6.947 8.685-9.429 3.474-2.233 7.692-3.473 12.903-3.473 7.692 0 13.895 2.233 18.858 6.947 4.714 4.715 7.195 11.414 7.195 19.85 0 5.211-1.24 9.926-3.473 14.144-2.482 4.218-5.46 7.94-8.933 11.166a106.47 106.47 0 01-11.91 8.933c-4.219 2.73-8.437 5.459-12.159 8.188-7.444 5.21-14.391 10.173-21.09 15.136-6.7 4.963-12.656 10.421-17.618 16.128-4.963 5.956-8.933 12.655-11.662 20.099-2.978 7.444-4.467 16.129-4.467 26.302h127.54V490.04h-82.132a74.195 74.195 0 0114.888-15.632c5.707-4.467 11.414-8.685 17.37-12.655 5.954-3.722 11.91-7.692 17.865-11.662a101.225 101.225 0 0015.632-13.4c4.714-4.714 8.436-10.42 11.166-16.624 2.73-6.203 4.218-13.895 4.218-22.58 0-8.436-1.489-16.128-4.714-22.828-3.226-6.7-7.693-12.406-13.151-17.12-5.46-4.715-11.91-8.19-18.858-10.67-7.196-2.482-14.888-3.722-22.828-3.722-10.422 0-19.603 1.737-27.543 5.21-8.188 3.722-14.888 8.685-20.098 14.888-5.211 6.452-9.181 13.895-11.91 22.332-2.73 8.684-3.723 17.865-3.475 27.79z"
      fill={token('color.text.subtle', '#253858')}
      fillRule="nonzero"
    />
  </>
);

// viewbox 0 0 591 591
const multiLevelCascadeSelect = (
  <>
    <path fill="none" d="M-.001 0H590.55v590.552H-.001z" />
    <path
      d="M531.426 139.841c0-4.846-3.93-8.776-8.774-8.776H173.583c-4.843 0-8.782 3.93-8.782 8.776v67.27c0 4.846 3.939 8.776 8.782 8.776h349.07c4.843 0 8.773-3.93 8.773-8.777v-67.269zM142.442 139.682c0-4.76-3.863-8.617-8.62-8.617H67.74c-4.758 0-8.622 3.858-8.622 8.617v67.58c0 4.759 3.864 8.625 8.622 8.625h66.081c4.758 0 8.62-3.866 8.62-8.625v-67.58z"
      fill="#e0e0e0"
    />
    <path
      d="M531.489 261.741a8.778 8.778 0 00-8.777-8.776H173.55c-4.844 0-8.784 3.93-8.784 8.776v67.27c0 4.846 3.94 8.776 8.784 8.776h349.163a8.778 8.778 0 008.777-8.777v-67.269zM142.4 261.59c0-4.76-3.864-8.625-8.623-8.625h-66.1c-4.758 0-8.624 3.866-8.624 8.625v67.572c0 4.759 3.866 8.625 8.625 8.625h66.1c4.758 0 8.622-3.866 8.622-8.625V261.59zM531.489 383.443a8.778 8.778 0 00-8.777-8.777H173.55c-4.844 0-8.784 3.93-8.784 8.777v67.269c0 4.846 3.94 8.776 8.784 8.776h349.163a8.778 8.778 0 008.777-8.776v-67.27zM142.4 383.291c0-4.759-3.864-8.625-8.623-8.625h-66.1c-4.758 0-8.624 3.866-8.624 8.625v67.572c0 4.76 3.866 8.625 8.625 8.625h66.1c4.758 0 8.622-3.866 8.622-8.625v-67.572z"
      fill="#ff3a01"
    />
  </>
);

/* tslint:enable max-line-length */

const IconSmall = styled.svg`
  width: 45px;
  margin-top: -1px;
  display: block;
`;

export const CepCustomFieldTypeIcon = ({ type, size }: { type?: string; size: string }) => {
  const { t } = useContext(GlobalContext);

  let fallbackType = 'incompatible';
  if (type && allowedTypes.indexOf(type) !== -1) {
    fallbackType = type;
  }
  const tooltipText = t('global.customfieldTypes.' + fallbackType);
  // NOTE: IE11 needs fixed height+width on the SVG !!!

  const widthForList = '25px';
  const heightForList = '25px';
  const widthRegular = '20px';
  const heightRegular = '20px';
  return (
    <>
      <div
        style={{
          minWidth: size === 'forlist' ? widthForList : widthRegular,
          width: size === 'forlist' ? widthForList : widthRegular,
          display: 'block',
          height: size === 'forlist' ? heightForList : heightRegular,
        }}
      >
        <Tooltip content={tooltipText}>
          <IconSmall
            viewBox="0 0 591 591"
            style={{
              fillRule: 'evenodd',
              width: size === 'forlist' ? widthForList : widthRegular,
              height: size === 'forlist' ? heightForList : heightRegular,
            }}
          >
            {fallbackType === 'multi-level-cascading-select' && multiLevelCascadeSelect}
            {fallbackType === 'cascadingselect' && cascadingselect}
            {fallbackType === 'multicheckboxes' && multicheckboxes}
            {fallbackType === 'multiselect' && multiselect}
            {fallbackType === 'radiobuttons' && radiobuttons}
            {fallbackType === 'select' && select}
            {fallbackType === 'incompatible' && incompatible}
          </IconSmall>
        </Tooltip>
      </div>
    </>
  );
};
